'use strict';

import { Component, Prop } from 'vue-property-decorator';
import PurchaseRequestFilter, { IPurchaseRequestFilter } from '@core/js/ddriven/application/http/requests/purchases/PurchaseRequestFilter.valueobject';
import EntityFiltersController from '@core/js/viewmodels/common/entity/EntityFiltersController.viewmodel';
import ExtendedDictionaryItem from '@core/js/ddriven/domain/model/common/dictionaries/ExtendedDictionaryItem.valueobject';
import isTypeOrNull from '@lib/js/src/misc/isTypeOrNull';

@Component
export default class PurchaseFiltersController extends EntityFiltersController {
    $data!: {
        filters: IPurchaseRequestFilter;
    };
    constructor() {
        super();
        this.name = 'PurchaseFiltersController';
    }

    created() {
        this.$data.filters = this.createRequestFilter(this.filterConstructor, this.$props.requestfilter);
    }

    @Prop({
        required: true,
        validator: (prop) => {
            return isTypeOrNull(prop, 'Array');
        }
    })
    readonly types!: ExtendedDictionaryItem[];

    get filterConstructor() {
        return PurchaseRequestFilter;
    }
}
